// src/store/pipeline.js

const SET_FINANCING_REQUESTS = "SET_FINANCING_REQUESTS";
const CLEAR_FINANCING_REQUESTS = "CLEAR_FINANCING_REQUESTS";

// -- Initial State --
const initialState = null;

// -- Reducer --
export default function financingRequestsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FINANCING_REQUESTS:
      return action.payload;

    case CLEAR_FINANCING_REQUESTS:
      return initialState;

    default:
      return state;
  }
}

// — action creators —
// implicit return, minimal object creation

export const financingRequestsSet = (payload) => ({
  type: SET_FINANCING_REQUESTS,
  payload,
});

// reset pipeline to initial
export const financingRequestsClear = () => ({
  type: CLEAR_FINANCING_REQUESTS,
});
